export default __webpack_public_path__ + "static/open_quote-c6bcaa729eb9f131a62f54007519ced9.svg";